<template>
  <div class="app">
    <!-- <router-view /> -->
    <TabsView />
  </div>
</template>

<script>
import TabsView from '@/layouts/TabsView'
import wxlogin from '@/mixin/wxlogin'
import Cookie from 'js-cookie'
// import { isWeChatBrowser } from '@/config/h5/index.js'
// window.vConsole.$dom.style.display = 'none'

export default {
  name: 'App',
  components: { TabsView },
  mixins: [wxlogin],
  data() {
    return {}
  },
  created() {
    // if (isWeChatBrowser) {
    //   this.getWXCode()
    // }
  },
  mounted() {
    window.addEventListener('beforeunload', e => this.set(e))
  },
  methods: {
    set() {
      Cookie.remove("paramsPro")
      Cookie.remove("cookieprodMeSel")
      Cookie.remove("cookieProTypeSel")
      Cookie.remove("cookieOrgSel")
    }
  }
}
</script>
<style>
.vc-switch {
  /* 关闭Vconsole */
  display: none !important;
}
</style>
